import styled from 'styled-components';
import {ArrowExpand, PlusCircled} from "assets/images";

export const Wrapper = styled.div`
    height: 100vh;
    width: 100%;
    padding: 20px 65px;
    display: flex;
    flex-direction: column;

    background-color: rgba(251, 255, 251, 1);

    textarea:focus, input:focus {
        outline: none;
    }

    * {
    }
`;
//
export const HeaderTitle = styled.h3`
    font-size: 24px;
`;

export const GroupNameInput = styled.input`
  outline: none;
  border: none;
  max-width: 200px;

  :focus {
    border-bottom: 2px solid #7CBE7B;
  }
`
export const TickerNameInput = styled(GroupNameInput)`
    max-width: 200px;

`

export const Workspace = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
    height: 100%;
    width: 100%;
    overflow: auto;
    flex-grow: 1;
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-self: flex-end;

    button {
        margin-right: 10px;
    }

`;

export const CustomArrowExpand = styled(ArrowExpand)`
    cursor: pointer;
    margin-right: 10px;
`;
export const CustomPlusCircled = styled(PlusCircled)`
    cursor: pointer;
    margin-right: 10px;

`;

export const SettingsBlockWrapper = styled.div`
    //min-width: 440px;
`;
export const CPSettingsBlockWrapper = styled.div`
    min-width: 330px;
`;
export const MDPSettingsBlockWrapper = styled.div`
    min-width: 270px;
`;

export const SettingsBlockHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;
export const SettingsBlockTitle = styled.h4`
    padding-left: 15px;
    font-size: 18px;
`;
export const SettingsBlockButtons = styled.div`

`;
export const BlockWrapper = styled.div`
    height: 90%;

`;










